export default __webpack_public_path__ + "static/media/alcibiades-colored.b0c27077.webp";